import { Layout, EditRoute as EditRouteComponent } from "components"
export const EditRoute = () => {
 return (
  <Layout>
   <EditRouteComponent />
  </Layout>
 )
}
